import {
	type FetchNftExternalAddressesParamsNetworkTypes,
	type NetworkType,
	type NFTExternalAddress,
	type RecipientItem,
	type RecipientTypes
} from '@capsicum/common';
import { useCallback } from 'react';

import { useExternalAddressQuery } from '../data-access/queries';

/**
 * @param recipientId - string
 * @returns external address information for recipient
 */
export const useMyCollectibleRecipient = (
	recipientId: string,
	networkTypes: Array<FetchNftExternalAddressesParamsNetworkTypes>
) =>
	useExternalAddressQuery(
		recipientId,
		networkTypes,
		useCallback((data?: Array<NFTExternalAddress> | undefined): Array<RecipientItem> | undefined => {
			return data?.map(recipient => {
				return {
					blockchainAddress: recipient.blockchainAddress,
					exchange: recipient.externalOwnerInfo?.walletOrExchangeName || '',
					id: recipient.id || '',
					label: recipient.label,
					networkType: recipient.tokenOwner.networkType as NetworkType,
					type: recipient.type as RecipientTypes
				};
			});
		}, [])
	);
